module.exports = __webpack_public_path__ + "img/32pll.128cb9f3.png";